export enum CleanType {
    CleanedOnArrival = 1,
    LoadWithoutCleaning = 2,
    CleanAtLoadLocation = 3
}
